<!--上传记录-->
<template>
    <div class="upload_record">
        <slot></slot>
        <div class="list_item" v-for="item in page.content">
            <img src="../assets/Img/upload.png"
                 class="img">
            <div class="detail_box">
                <div class="name"> {{item.uploadername}} {{item.uploadtime}}</div>
                <div class="status"> 录入一个 <span class="red">{{item.volumename}}</span></div>
				
            </div>
			<div class="cat"><button class="btn" @click="viewUpload(item)">查看</button></div>
        </div>
        <Pager :page="page" @load="loadList"></Pager>
		
		<el-dialog title="上传详情" :visible.sync="dialogTableVisible" class="down_dialog">
			<p><span>册名</span>: {{detail.volumename}}</p>
			<p><span>地区名称</span>: {{detail.areaname}}</p>
			<p><span>地区层级</span>: {{detail.arealevel}}</p>
			<p><span>年代层级</span>: {{detail.yearlevel}}</p>
			<p><span>编撰者</span>: {{detail.author}}</p>
			<p><span>出版单位</span>: {{detail.publisher}}</p>
			<p><span>年份</span>: {{detail.year}}</p>
			<p><span>纯净度</span>: {{detail.purity}}</p>
			<p><span>上传时间</span>: {{detail.uploadtime}}</p>
		</el-dialog>
    </div>
</template>

<script>
	
    import Pager from '../components/Pager'
    export default {
        components: {Pager},
        data() {
            return {
                userInfo: JSON.parse(sessionStorage.getItem('loginData')) || {},
                auditstatus: {
                    0: '待审核',
                    1: '审核通过',
                    2: '审核不通过'
                },
				dialogTableVisible:false,
				detail: {},
                page: {
                    size: 10,
                    number: 0,
                    content: [],
                    totalElements: 0
                }
            }
        },
        mounted() {
            this.loadList();
			this.addVisit();
        },
        methods: {
			//增加点击量
			addVisit(){
			    request('/apiVisit/addVisitData', {module: 101}).then(res=>{
			       
			    })
			},
			viewUpload(item) {
			    this.detail = item;
			    this.dialogTableVisible = true;
			},
            loadList() {
                this.$request('/apidfz/listLcUploadApply', {
                    userid: this.userInfo.userId,
                    limit: this.page.size,
                    offset: this.page.number
                }).then(res => {
                    if (res.code === 200) {
                        this.page.content = res.data
                        this.page.totalElements = res.count
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped lang="less" rel="stylesheet/less">
	.down_dialog{
		width: 80%;
		margin: 0 auto;
	}
	.down_dialog p{
		color: #519b96;
		height: 30px;
		line-height: 30px;
		width: 49%;
		margin: 15px 30%;
		font-size: 13px;
		font-weight: bold;
		box-shadow: 2px 2px 3px #f7f7f7;
	}
	.down_dialog p span{
		font-size: 12px;
		color: #12837b;
		margin-right: 5px;

	}
    .upload_record {
        padding: 10px 20px;
        flex: 1;
        border: 1px solid #eaeaea;
        border-radius: 3px;
        margin-left: 10px;

        .title {
            font-size: 20px;
            text-align: center;
        }

        .list_item {
            width: 100%;
			height: 70px;
			align-items: center;
			border-top: 1px solid #e5e5e5;
			padding: 15px 10px;
			box-sizing: border-box;
			margin-top: 5px;
		
            .img {
                width: 30px;
                height: 30px;
				float: left;
            }

            .detail_box {
                margin-left: 15px;
				float: left;

                .name {
                    font-size: 14px;
                }

                .status {
                    font-size: 14px;
                }

                .red {
                    color: red;
                }
            }
			.cat{
				float: right;
				
				.btn{
					padding: 5px;
					border-radius: 5px;
					background-color: white;
					border: 1px solid #dbd3d3;
					color: #286956;
					width: 50px;
					cursor: pointer;
				}
				.btn:hover{
					padding: 5px;
					border-radius: 5px;
					background-color: white;
					border: 1px solid #dbd3d3;
					color: #29b78e;
					width: 50px;
					cursor: pointer;
				}
			}
        }
		.list_item:hover {
		    width: 100%;
			height: 70px;
			align-items: center;
			border-top: 1px solid #e5e5e5;
			padding: 15px 10px;
			box-sizing: border-box;
			background-color: #f8f8f8;
		}
    }
</style>